import React from 'react';
import { Mail, ExternalLink, Calendar, FileText } from 'lucide-react';
import { FooterLogo } from './Logo';

const HEADSHOT_URL = 'https://dim.mcusercontent.com/cs/b42918b71e14f4a563072803f/images/003e86e7-b9ec-e5c2-ea02-db16569b3859.jpg';

export const TrustBlock = () => {
  return (
    <div data-testid="trust-block" className="bg-slate-50 border-t border-slate-200">
      <div className="max-w-4xl mx-auto px-6 py-16 md:py-20">
        <div className="flex flex-col items-center text-center">
          {/* Headshot */}
          <div 
            data-testid="expert-headshot"
            className="w-28 h-28 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-gold-400 shadow-lg mb-6"
          >
            <img 
              src={HEADSHOT_URL} 
              alt="Sanam Bawa" 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Info */}
          <h3 className="text-2xl md:text-3xl font-heading font-semibold text-navy-950 mb-1">
            Sanam Bawa
          </h3>
          <p className="text-gold-500 font-medium text-lg mb-4">
            Mortgage Professional
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-slate-600 text-sm mb-8">
            <a 
              href="mailto:sanam@everythingmortgages.ca"
              className="flex items-center gap-2 hover:text-gold-500 transition-colors"
            >
              <Mail className="w-4 h-4" />
              sanam@everythingmortgages.ca
            </a>
            <span className="hidden sm:inline text-slate-400">|</span>
            <span>License #M15001292</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full max-w-xl">
            <a
              href="https://calendly.com/sanam-everythingmortgages/30min"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="schedule-review-btn"
              className="flex-1 inline-flex items-center justify-center gap-2 bg-gold-400 text-navy-950 hover:bg-gold-500 font-heading font-semibold px-6 py-4 rounded-xl shadow-md hover:shadow-lg transition-all"
            >
              <Calendar className="w-5 h-5" />
              Schedule My Audit Review
            </a>
            <a
              href="https://app.scarlettnetwork.com/Sanamdeep_Bawa"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="start-application-btn"
              className="flex-1 inline-flex items-center justify-center gap-2 bg-white border-2 border-slate-300 text-navy-950 hover:border-gold-400 hover:text-gold-500 font-heading font-semibold px-6 py-4 rounded-xl transition-all"
            >
              <FileText className="w-5 h-5" />
              Start Application
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>

        {/* Footer Logo */}
        <div className="mt-16 pt-8 border-t border-slate-200">
          <div className="flex justify-center">
            <FooterLogo />
          </div>
        </div>
      </div>
    </div>
  );
};
